import React from "react";
import MatchTime from "@/components/KbvMatchTime";
//import { useLiveDataForMatch } from "@/hooks/useLiveData";
//import { useMatchData } from "@/hooks/useMatchData";
import MatchCards from "@/components/KbvMatchCards";
import ICON_CORNER from "@/assets/images/corner.svg";
import { LIVE_STATUSES, FINISHED_STATUSES, NOT_STARTED_STATUS } from "@/contants";

export default function Match({ match, swapScoreCorner = false }) {
  //const { getScore } = useLiveDataForMatch(match.id);
  const homeOdds = match.handicapOdds?.[0]?.initialHome;

  const handicapValue = match.handicapOdds?.[0]?.initialHandicap;
  const isAwayHandicap = parseFloat(handicapValue) < 0;
  const awayOdds = match.handicapOdds?.[0]?.initialAway;

  //const liveScore = getScore();

  // const liveStatus =
  //   liveScore?.status !== undefined
  //     ? Number(liveScore.status)
  //     : Number(match.status);
  const statusNum = Number(match.status);

  const isLive = LIVE_STATUSES.includes(statusNum);
  const isFinished = FINISHED_STATUSES.includes(statusNum);
  const isNotStarted = NOT_STARTED_STATUS.includes(statusNum);

  // const {
  //   currentHomeScore,
  //   currentAwayScore,
  //   currentHomeHalfScore,
  //   currentAwayHalfScore,
  //   isHomeWin,
  //   isAwayWin,
  //   homeYellow,
  //   homeRed,
  //   awayYellow,
  //   awayRed,
  //   currentHomeCorner,
  //   currentAwayCorner,
  // } = useMatchData(liveScore, match);

  const {
    homeScore: currentHomeScore,
    awayScore: currentAwayScore,
    homeHalfScore: currentHomeHalfScore,
    awayHalfScore: currentAwayHalfScore,
    isHomeWin = false,
    isAwayWin = false,
    homeYellow,
    awayYellow,
    homeRed,
    awayRed,
    homeCorner: currentHomeCorner,
    awayCorner: currentAwayCorner,
  } =  match;

  const shouldSwapScoreCorner = swapScoreCorner && isFinished;

  return (
    <div className="border border-gray-200 rounded-lg p-2 flex items-center gap-3">
      <div className="flex items-center gap-1 min-w-[60px]">
        <MatchTime
          homeCorner={currentHomeCorner}
          awayCorner={currentAwayCorner}
          homeScore={currentHomeScore}
          awayScore={currentAwayScore}
          swapScoreCorner={shouldSwapScoreCorner}
          isLive={isLive}
          isFinished={isFinished}
          isNotStarted={isNotStarted}
          matchTime={match.matchTime}
          liveScore={null}
          status={statusNum}
          halfStartTime={match.halfStartTime}
        />
      </div>

      <div className="flex-1 flex flex-col gap-2">
        <div className="flex items-center justify-between gap-2">
          <div className="flex gap-1">
            {match.homeTeam?.logo && (
              <img
                src={match.homeTeam?.logo}
                alt={match.homeName}
                width={20}
                height={20}
                className="rounded-full"
              />
            )}
            <div className="flex gap-1 truncate">
              <span
                className={`text-sm flex-1 ${isHomeWin ? "font-bold" : ""
                  } ${!isNotStarted ? "truncate max-w-[120px]" : "max-w-[170px]"
                  }`}
              >
                {match.homeName}
              </span>
              <MatchCards
                yellow={homeYellow}
                red={homeRed}
                direction="home"
              />
            </div>
          </div>
          {!isNotStarted && (
            <span
              className={`text-sm min-w-[10px] tabular-nums text-center ${isHomeWin ? "font-bold" : ""
                }`}
            >
              {shouldSwapScoreCorner ? (
                <span className="inline-flex items-center gap-1">
                  <img src={ICON_CORNER} alt="corner" width={10} height={10} />
                  <span>{currentHomeCorner}</span>
                </span>
              ) : (
                currentHomeScore
              )}
              {!shouldSwapScoreCorner && (
                <span className="ml-1 text-sm text-[var(--text-half-score)] font-normal">
                  ({currentHomeHalfScore})
                </span>
              )}
            </span>
          )}
        </div>
        <div className="flex items-center justify-between gap-2">
          <div className="flex gap-1">
            {match.awayTeam?.logo && (
              <img
                src={match.awayTeam?.logo}
                alt={match.awayName}
                width={20}
                height={20}
                className="rounded-full"
              />
            )}
            <div className="flex gap-1 truncate">
              <span
                className={`text-sm flex-1 ${isAwayWin ? "font-bold" : ""
                  } ${!isNotStarted ? "truncate max-w-[120px]" : "max-w-[170px]"
                  }`}
              >
                {match.awayName}
              </span>
              <MatchCards
                yellow={awayYellow}
                red={awayRed}
                direction="away"
              />
            </div>
          </div>
          {!isNotStarted && (
            <span
              className={`text-sm min-w-[10px] tabular-nums text-center ${isAwayWin ? "font-bold" : ""
                }`}
            >
              {shouldSwapScoreCorner ? (
                <span className="inline-flex items-center gap-1">
                  <img src={ICON_CORNER} alt="corner" width={10} height={10} />
                  <span>{currentAwayCorner}</span>
                </span>
              ) : (
                currentAwayScore
              )}
              {!shouldSwapScoreCorner && (
                <span className="ml-1 text-sm text-[var(--text-half-score)] font-normal">
                  ({currentAwayHalfScore})
                </span>
              )}
            </span>
          )}
        </div>
      </div>

      {!isFinished && (
        <div className="flex flex-col gap-2 min-w-[80px] items-end">
          <div className="flex items-center gap-2">
            {!isAwayHandicap && (
              <span className="text-sm text-blue-500">{`${parseFloat(handicapValue) > 0
                  ? `-${handicapValue}`
                  : handicapValue
                }`}</span>
            )}
            <span className="text-sm">{homeOdds}</span>
          </div>
          <div className="flex items-center gap-2">
            {isAwayHandicap && (
              <span className="text-sm text-blue-500">
                {handicapValue}
              </span>
            )}
            <span className="text-sm">{awayOdds}</span>
          </div>
        </div>
      )}
    </div>
  );
}